if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"corksyAdmin","remotes":[{"alias":"corksyOrders","name":"corksyOrders","entry":"https://mf-order.corksy.io/corksy-orders.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(3(293|915|932)|4(168|353|407|421|667|999)|5(3(72|74|90)|576|902|965)|6(013|127|516|68|86)|7(041|396|798|895)|8(24[14]|18|779)|1169|1291|2089|2315|94)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}